import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listProjectMetas, deleteProjectCascade } from '../storage/projectRepository';

export const PROJECTS_QUERY_KEY = ['projects', 'local'];

export function useProjectsList() {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEY,
    queryFn: listProjectMetas,
  });
}

export function useDeleteProject() {
  const queryClient = useQueryClient();
  return async (projectId: string) => {
    await deleteProjectCascade(projectId);
    await queryClient.invalidateQueries({ queryKey: PROJECTS_QUERY_KEY });
  };
}
